import React, { useState } from 'react';
import { FormControl, FormGroup, FormControlLabel, FormLabel, FormHelperText, Paper, useForkRef, Typography, TextField, Button, CircularProgress, Fade, Backdrop } from '@material-ui/core';
// import Signature from './Signature';
import _, { isEmpty, omit, pick, round, slice } from 'lodash';
import PF from "../_Services/publicFunction";
import Qs from "qs";
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../reducers/app";
import useSound from 'use-sound';
import switchlight from '../sounds/switchlight.wav';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider, KeyboardDatePicker, DatePicker, KeyboardDateTimePicker, KeyboardTimePicker } from "@material-ui/pickers";
import TodayIcon from "@material-ui/icons/UpdateOutlined";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useSnackbar } from "notistack";
// import Example from "./components/LHTable/Example"
import InteriorTable from "../components/LHTable/DataSheet_Virtual"
import Example from '../components/LHTable/Example';
import { indigo, teal, deepPurple } from '@material-ui/core/colors'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { FormattedMessage, injectIntl, intlShape, useIntl } from 'react-intl';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },

    half_background: {
        background: "linear-gradient(to top, yellow 50%, transparent 50%)"
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    "data-grid": {
        width: "100%"
    }
}));

const WeeklyBooking = props => {
    const filterOptions = createFilterOptions({
        matchFrom: 'any',
        stringify: (option) => "[" + option.ProjectNo + "]" + option.ProjectName,
    });
    const { enqueueSnackbar } = useSnackbar();
    const dispatch = useDispatch();
    const classes = useStyles();
    const initialRender = React.useRef(true);
    const { dark } = useSelector(state => ({
        dark: state.app.dark,
    }));
    const intl = useIntl();

    const formRef = React.createRef();
    const [playActive] = useSound(
        switchlight,
        { volume: 0.5 }
    );
    const [loading, setLoading] = React.useState(false);

    //查詢條件

    const [settingObj, setObj] = React.useState({
        startDate: { label: "健檢日期(起)", name: "startDate", format: "date", required: true, disableFuture: true, value: null },
        endDate: { label: "健檢日期(迄)", name: "endDate", format: "date", required: true, disableFuture: true, placeholder: "2000/01/01", value: null },
        projectNo: { label: "專案名稱", name: "projectNo", format: "text", required: true }
    })

    const [rows, setRows] = useState([]);
    //選中的範圍
    const [selected, setSelected] = React.useState({ start: null, end: null })
    //用於表的快速移動至某行
    const listRef = React.createRef();
    //勾選
    const [checkSelections, setCheckSelections] = React.useState(new Map());
    //允許多個勾選
    const [enableCheck, setEnableCheck] = React.useState(false);
    //允許多個勾選
    const [multiChk, setMultiChk] = React.useState(false);
    //總頁數
    const [pageCount, setPageCount] = React.useState(1)
    //第幾頁
    const [pageNo, setPageNo] = React.useState(6)
    const [columns, setColumns] = React.useState({
        BarCodeStr: { label: "BarCodeStr", name: "BarCodeStr", width: 100, type: "text", required: false, noShowSelect: true, orderSeq: 1 },
        Name: { label: "Name", name: "Name", width: 100, type: "text", required: true, xs: 6, sm: 6, md: 3, orderSeq: 2 },
        SpecNo66: { label: "SpecNo66", name: "SpecNo66", width: 100, type: "text", required: true, noShowSelect: true, xs: 6, sm: 6, md: 3, orderSeq: 4 },
        ID: { label: "ID", name: "ID", width: 100, type: "text", required: true, xs: 6, sm: 6, md: 3, noShowSelect: true, orderSeq: 3 },
    })
    React.useEffect(() => {
        let noshowTable = [];
        Object.values(columns).map(item => {
            if (item.noshowTable === true) {
                // console.log(item.name)
                noshowTable.push(item.name)
            }
        })
        let showColumns = _.omit(columns, noshowTable);        //轉換
        setOrderRows(prev => PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    }, [columns])
    //轉換
    let noshowTable = [];
    Object.values(columns).map(item => {
        if (item.noshowTable === true) {
            // console.log(item.name)
            noshowTable.push(item.name)
        }
    })
    let showColumns = _.omit(columns, noshowTable)
    // const [showColumns, setShowColumn] = React.useState(_.omit(columns, noshowTable))
    //let z22 = _.orderBy(z2, ['orderSeq']);  //排序
    //let z3 = z2.map(item=>(item.name));//只取標頭
    // console.log(z22);     //依照column順序排序
    const [orderRows, setOrderRows] = React.useState(PF.dataSheetGridFormat(rows, Object.keys(showColumns)))
    //雙擊
    const handleDoubleClick = (i, j, e) => {
        console.log(rows[i]);
    }
    const RowStyleFunc = (rows, index) => {
        return "";
    }


    const handleQuery = prop => {
        if (validator()) {
            setLoading(true);
            PF.instance({
                method: "post",
                url: PF.url + "/CheckProject/Update66",
                data: Qs.stringify({ Action: "Update", parameter: { startDate: settingObj.startDate.value, endDate: settingObj.endDate.value, ProjectNo: settingObj.projectNo.value } }),
                // headers: { token: sessionStorage.token }
            })
                .then(function (response) {
                    // alert("完成")
                    const { TotalRecord, rows } = response.data;
                    console.log(rows)
                    if (TotalRecord > 0) {
                        enqueueSnackbar("更新成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                        setRows(prev => rows);
                        setOrderRows(prev => [...PF.dataSheetGridFormat(rows, Object.keys(showColumns))]);

                    }
                    else {
                        enqueueSnackbar("更新失敗", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                    }
                    setLoading(false);
                })
        }
    };
    const handleDateChange = (name, e, v) => {
        setObj(prevState => ({
            ...prevState,
            [name]: {
                ...prevState[name],
                value: v
            }
        }));
    }
    const handleTxtChange = e => {
        // const { name, value } = e.target;

    }
    const [ProjectList, setProjectList] = React.useState([]);

    React.useEffect(() => {
        setLoading(true)
        PF.instance({
            method: "post",
            url: PF.url + "/CheckProject/GetData",
            data: Qs.stringify({ parameter: { projectName: "" } }),
            // headers: { token: sessionStorage.token }
        })
            .then(function (response) {
                // alert("完成")
                const { TotalRecord, rows } = response.data;
                // console.log(rows)
                if (TotalRecord > 0) {
                    enqueueSnackbar("查詢成功", { variant: "success", style: { whiteSpace: 'pre-line' } });
                    setProjectList(rows)

                }
                else {
                    enqueueSnackbar("查無資料", { variant: "warning", style: { whiteSpace: 'pre-line' } });
                }
                setLoading(false);
            })

    }, []);
    const handleAutoCompleteChange = (e, v) => {
        console.log(v)  //一筆資料
        setObj(prevState => ({
            ...prevState,
            projectNo: { ...prevState.projectNo, value: v === null ? null : v.ProjectNo }
        }))

    }

    const validator = () => {
        const form = formRef.current; //參數1
        if (form.checkValidity()) {
            console.log("全部通過");
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (Object.keys(settingObj).includes(element.name)) {
                    setObj(prevState => ({
                        ...prevState,
                        [element.name]: omit(prevState[element.name], ["error"])
                    }))
                }
            }
            return true;
        } else {
            for (let i = 0; i < form.elements.length; i++) {
                const element = form.elements[i];
                if (element.tagName !== 'button' && element.willValidate && !element.validity.valid) {  //提交按鈕不用驗證
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: { ...prevState[element.name], error: true, helperText: intl.formatMessage({ id: element.validationMessage }) }
                        }))
                    }
                    // console.log(element.validationMessage)

                } else {//驗證通過，自訂訊息
                    //有在settingObj的
                    if (Object.keys(settingObj).includes(element.name)) {
                        setObj(prevState => ({
                            ...prevState,
                            [element.name]: omit(prevState[element.name], ["error"])
                        }))
                    }

                }
            }
            return false;
        }
    }


    return (
        <>
            <Paper elevation={3} style={{ margin: "10px", padding: "20px" }}>
                <DarkModeSwitch
                    style={{ marginBottom: '2rem', float: "right" }}
                    checked={dark}
                    onChange={() => dispatch(actions.THEME_SET({ theme: !dark }))}
                    onMouseDown={() => playActive()}
                    size={20} />
                <form ref={formRef}>
                    <FormControl style={{ display: "inline-block" }}>
                        <Autocomplete
                            onChange={handleAutoCompleteChange}
                            options={ProjectList}
                            getOptionLabel={(option) => option.ProjectName} //大小寫須一致
                            filterOptions={filterOptions}
                            renderOption={(option) => (//表達格式
                                <React.Fragment>
                                    [{option.ProjectNo}] {option.ProjectName}
                                </React.Fragment>
                            )}
                            style={{ width: 300 }}
                            renderInput={(params) =>
                                <TextField
                                    error={settingObj.projectNo.error || false}
                                    helperText={settingObj.projectNo.error ? settingObj.projectNo.helperText : ""}
                                    name={"projectNo"}
                                    required={true}  {...params}
                                    label="專案名稱" variant="outlined" />}
                        />
                    </FormControl>

                    <MuiPickersUtilsProvider utils={MomentUtils}>
                        {Object.values(settingObj).slice(0, 2).map((item, key) => {
                            if (item.format === "date") {

                                return (<KeyboardDatePicker
                                    format="YYYY/MM/DD"
                                    key={key}
                                    views={["year", "month", "date"]}
                                    // fullWidth
                                    autoOk
                                    autoComplete="off"
                                    clearable
                                    type="datetime"
                                    name={item.name}
                                    required={item.required}
                                    error={item.error || false}
                                    helperText={
                                        item.error ? (
                                            item.helperText
                                        ) : null
                                    }
                                    todayLabel={< TodayIcon />}
                                    showTodayButton
                                    minDate={item.minDate || new Date("1900-01-01")}
                                    maxDate={item.maxDate || new Date("2100-01-01")}
                                    clearLabel={"清除"}
                                    label={item.label}
                                    value={item.value}
                                    inputValue={item.value}
                                    onChange={(event, value) =>
                                        handleDateChange(item.name, event, value)
                                    }
                                />
                                )
                            } else {
                                return (<TextField
                                    // variant="filled"
                                    key={key}
                                    helperText={item.error ? item.helperText : null}
                                    autoComplete="off"
                                    error={item.error || false}
                                    required={item.required || false}
                                    // fullWidth
                                    name={item.name}
                                    label={item.label}
                                    inputProps={{ ...item }}
                                    value={item.value}
                                    onChange={handleTxtChange}
                                    inputProps={{
                                        ...item //像是minLength、pattern
                                        // pattern: "[0-9]{4}/(0[1-9]|1[012])/(0[1-9]|1[0-9]|2[0-9]|3[01])"
                                    }} />
                                )

                            }

                        })}
                        <Button onClick={handleQuery} variant={"outlined"}>更新</Button>
                    </MuiPickersUtilsProvider>

                </form>
                <br />
                <InteriorTable
                    width={"100%"}
                    style={{ width: "100%" }}
                    className={classes['data-grid']}
                    orderRows={orderRows}                    //需轉換格式
                    setRows={setRows}           //傳入方法
                    rows={rows}         //原來傳入
                    setOrderRows={setOrderRows}
                    // columns={Object.values(showColumns)} //需轉換格式
                    showColumns={showColumns}
                    setColumns={setColumns}     //傳入方法
                    columns={columns}   //原來傳入
                    enableCheck={enableCheck}   //不允許更改
                    multiChk={multiChk} //允許多選checkBOx
                    checkSelections={checkSelections}       //checkBox
                    setCheckSelections={setCheckSelections} //checkBox方法
                    listRef={listRef}   //用來scroll to an item
                    pageCount={pageCount}
                    pageNo={pageNo}
                    setPageNo={setPageNo}
                    handleDoubleClick={handleDoubleClick}
                    selected={selected}
                    setSelected={setSelected}
                    defaultFrozen={1}
                    defaultWidth={"95%"}
                    RowStyleFunc={RowStyleFunc}
                    CopyWithHeader={true}
                />


            </Paper>
            <Backdrop className={classes.backdrop} open={loading} >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>);
}
export default WeeklyBooking;